type Props = {
    label: string;
    type?: null | "subtle";
}

const Chip = (props: Props) => {
    const { label, type } = props;

    return (
        <div className={`d-inline-block ${type === 'subtle' ? 'bg-dark-subtle' : 'bg-primary text-white'} rounded-pill py-1 px-3 me-2 mb-2`}>
            {label}
            <span className="svg-inside remove-choice" />
        </div>
    )
}

export default Chip;